import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_URL } from "assets/Contsants";

export default function Dashboard() {
  const [dashboardCount, setDashboardCount] = useState(null);

  const fetchCount = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${API_URL}/api/dashboard`,
        // {
        //     headers: {
        //         Authorization: `Bearer ${token}`
        //     }
        // }
      );

      setDashboardCount(response.data);
    } catch (error) {
      console.error('Error fetching user:', error);
    }
  };

  useEffect(() => {
    fetchCount();
  }, []);

  return (
    <>
      <div className="parkinsans text-black font-semibold">
        <div className="flex xl:gap-12">
          <div className=" xl:w-3/12">
            <Sidebar />
          </div>
          <div className=" xl:w-9/12 xl:-ml-28 my-12 flex gap-6">
            <div
              className="xl:p-4 rounded-xl xl:w-5/12"
              style={{
                backgroundColor: "#f0f7fa",
              }}
            >
              <a href="/admissiondashboard">
                <div className="">
                  <div className="flex gap-4 ">
                    <div className="bg-white h-10 w-10 rounded-lg ">
                      <i className="las la-user-circle xl:text-4xl pt-1 text-black flex mx-auto justify-center"></i>
                    </div>
                    <p className="text-black xl:text-base font-semibold">
                      Admission
                    </p>
                  </div>
                  <div className="justify-between items-center flex xl:pt-2">
                    <h5 className="text-gray-600 xl:text-3xl font-medium ">
                    {dashboardCount ? dashboardCount.admissions : ''}
                    </h5>
                    <h6 className="flex space-x-2 items-center text-blue xl:text-base font-semibold">
                      <a
                        href="/admissiondashboard"
                        className="flex items-center"
                      >
                        <i className="las la-arrow-right"></i>
                      </a>
                    </h6>
                  </div>
                </div>
              </a>
            </div>

            <div
              className="xl:p-4 rounded-xl xl:w-5/12"
              style={{
                backgroundColor: "#F1E1C8",
              }}
            >
              <a href="/franchisedashboard">
                <div className="">
                  <div className="flex gap-4 ">
                    <div className="bg-white h-10 w-10 rounded-lg ">
                      <i className="las la-user-circle xl:text-4xl pl-1 pt-1 text-black flex mx-auto justify-center"></i>
                    </div>
                    <p className="text-black xl:text-base font-semibold">
                      Franchise
                    </p>
                  </div>
                  
                  <div className="justify-between items-center flex xl:pt-2">
                    <h5 className="text-gray-600 xl:text-3xl font-medium ">
                    {dashboardCount ? dashboardCount.franchises : ''}
                    </h5>
                    <h6 className="flex space-2 items-center text-blue xl:text-base font-semibold ">
                      <a
                        href="/franchisedashboard"
                        className="flex items-center"
                      >
                        <i className="las la-arrow-right"></i>
                      </a>
                    </h6>
                  </div>
                </div>
              </a>
            </div>

            <div
              className="xl:p-4 rounded-xl xl:w-5/12"
              style={{
                backgroundColor: "#DADADA",
              }}
            >
              <a href="/careerdashboard">
                <div className="">
                  <div className="flex gap-4 ">
                    <div className="bg-white h-10 w-10 rounded-lg ">
                      <i className="las la-user-circle xl:text-4xl pl-1 pt-1 text-black flex mx-auto justify-center"></i>
                    </div>
                    <p className="text-black xl:text-base font-semibold">
                      Career
                    </p>
                  </div>
                 
                  <div className="justify-between items-center flex xl:pt-2">
                    <h5 className="text-gray-600 xl:text-3xl font-medium ">
                    {dashboardCount ? dashboardCount.careers : ''}
                    </h5>
                    <h6 className="flex space-2 items-center text-blue xl:text-base font-semibold ">
                      <a href="/careerdashboard" className="flex items-center">
                        <i className="las la-arrow-right"></i>
                      </a>
                    </h6>
                  </div>
                </div>
              </a>
            </div>

            <div
              className="xl:p-4 rounded-xl xl:w-5/12"
              style={{
                backgroundColor: "#FEFACF",
              }}
            >
              <a href="/enquirydashboard">
                <div className="">
                  <div className="flex gap-4 ">
                    <div className="bg-white h-10 w-10 rounded-lg ">
                      <i className="las la-user-circle xl:text-4xl pl-1 pt-1 text-black flex mx-auto justify-center"></i>
                    </div>
                    <p className="text-black xl:text-base font-semibold">
                      Enquiry
                    </p>
                  </div>
                  
                  <div className="justify-between items-center flex xl:pt-2">
                    <h5 className="text-gray-600 xl:text-3xl font-medium ">
                    {dashboardCount ? dashboardCount.enquiries : ''}
                    </h5>
                    <h6 className="flex space-2 items-center text-blue xl:text-base font-semibold ">
                      <a href="/enquirydashboard" className="flex items-center">
                        <i className="las la-arrow-right"></i>
                      </a>
                    </h6>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
